module.exports = __webpack_public_path__ + "static/8-before.aa96b971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/8-before.jpg
// module id = 432
// module chunks = 221374088121123